import React, { useState, Fragment } from 'react'

import PropTypes from 'prop-types'

import './features25.css'
import { useTranslation } from 'react-i18next';

const Features25 = ({
  feature1Title = undefined,
  feature1ImgAlt = undefined,
  feature1Description = undefined,
  feature1ImgSrc = undefined,
  feature2Title = undefined,
  feature2ImgAlt = undefined,
  feature2Description = undefined,
  feature2ImgSrc = undefined,
  feature3Title = undefined,
  feature3ImgAlt = undefined,
  feature3Description = undefined,
  feature3ImgSrc = undefined,
  feature4Title = undefined,
  feature4ImgAlt = undefined,
  feature4Description = undefined,
  feature4ImgSrc = undefined
}) => {
  const [activeTab, setActiveTab] = useState(0)
  const { t, i18n } = useTranslation();
  const lang = i18n.language === 'es' ? 'es' : 'en';

  return (
    <div className="thq-section-padding">
      <div className="features25-container2 thq-section-max-width">
        <div className="features25-tabs-menu">
          <div
            onClick={() => setActiveTab(0)}
            className="features25-tab-horizontal1"
          >
            <div className="features25-divider-container1">
              {activeTab === 0 && <div className="features25-container3"></div>}
            </div>
            <div className="features25-content1">
              <h2 className="thq-heading-2">
                {feature1Title ?? (
                  <Fragment>
                    <span className="features25-text4">
                      <h2>{t('features.onlinePayments.title')}</h2>
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {feature1Description ?? (
                  <Fragment>
                    <span className="features25-text2">
                      <p>{t('features.onlinePayments.description')}</p>
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(1)}
            className="features25-tab-horizontal2"
          >
            <div className="features25-divider-container2">
              {activeTab === 1 && <div className="features25-container4"></div>}
            </div>
            <div className="features25-content2">
              <h2 className="thq-heading-2">
                {feature2Title ?? (
                  <Fragment>
                    <span className="features25-text3">
                      <h2>{t('features.crmLite.title')}</h2>
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {feature2Description ?? (
                  <Fragment>
                    <span className="features25-text5">
                      <p>{t('features.crmLite.description')}</p>
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(2)}
            className="features25-tab-horizontal3"
          >
            <div className="features25-divider-container3">
              {activeTab === 2 && <div className="features25-container5"></div>}
            </div>
            <div className="features25-content3">
              <h2 className="thq-heading-2">
                {feature3Title ?? (
                  <Fragment>
                    <span className="features25-text6">
                      <h2>{t('features.ads.title')}</h2>
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {feature3Description ?? (
                  <Fragment>
                    <span className="features25-text1">
                      <p>{t('features.ads.description')}</p>
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(3)}
            className="features25-tab-horizontal4"
          >
            <div className="features25-divider-container4">
              {activeTab === 3 && <div className="features25-container6"></div>}
            </div>
            <div className="features25-content4">
              <h2 className="thq-heading-2">
                {feature4Title ?? (
                  <Fragment>
                    <span className="features25-text7">
                      <h2>{t('features.qrFlyers.title')}</h2>
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {feature4Description ?? (
                  <Fragment>
                    <span className="features25-text8">
                      <p>{t('features.qrFlyers.description')}</p>
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
        <div className="features25-image-container">
          {activeTab === 0 && (
            <img
              alt={feature1ImgAlt ?? t('features.onlinePayments.title')}
              src={feature1ImgSrc ??  `images/features/online-payments-${lang}.jpg`}
              className="features25-image1 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 1 && (
            <img
              alt={feature2ImgAlt ?? t('features.crmLite.title')}
              src={feature2ImgSrc ?? `images/features/crm-lite-${lang}.jpg`}
              className="features25-image2 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 2 && (
            <img
              alt={feature3ImgAlt ?? t('features.ads.title')}
              src={feature3ImgSrc ?? `images/features/advertising-${lang}.jpg`}
              className="features25-image3 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 3 && (
            <img
              alt={feature4ImgAlt ?? t('features.qrFlyers.title')}
              src={feature4ImgSrc ?? `images/features/qr-flyers-${lang}.jpg`}
              className="features25-image4 thq-img-ratio-16-9"
            />
          )}
        </div>
      </div>
    </div>
  )
}

Features25.propTypes = {
  feature1Title: PropTypes.element,
  feature1ImgAlt: PropTypes.string,
  feature1Description: PropTypes.element,
  feature1ImgSrc: PropTypes.string,
  feature2Title: PropTypes.element,
  feature2ImgAlt: PropTypes.string,
  feature2Description: PropTypes.element,
  feature2ImgSrc: PropTypes.string,
  feature3Title: PropTypes.element,
  feature3ImgAlt: PropTypes.string,
  feature3Description: PropTypes.element,
  feature3ImgSrc: PropTypes.string,
  feature4Title: PropTypes.element,
  feature4ImgAlt: PropTypes.string,
  feature4Description: PropTypes.element,
  feature4ImgSrc: PropTypes.string,
}

export default Features25
